export var RequestStatus;

(function (RequestStatus) {
  RequestStatus[RequestStatus["EXECUTE"] = 1] = "EXECUTE";
  RequestStatus[RequestStatus["SUCCESS"] = 2] = "SUCCESS";
  RequestStatus[RequestStatus["ERROR"] = 3] = "ERROR";
  RequestStatus[RequestStatus["RESET"] = 4] = "RESET";
})(RequestStatus || (RequestStatus = {}));